import React, { memo, useMemo } from 'react';
import { AWStageMemberDto } from '@api/Api';
import AvatarsGroup from '@components/AvatarsGroup/AvatarsGroup';
import type { MemberDecisionProps } from '@components/Approval/MemberDecision';

type DecisionsCellProps = {
  members: AWStageMemberDto[];
  assetVersionId: string;
  isPastDueDate: boolean;
  maxCount?: number;
};

export default memo(function DecisionsCell({
  members,
  isPastDueDate,
  assetVersionId,
  maxCount = 5
}: DecisionsCellProps) {
  const _members = useMemo(() => {
    return members.map((item) => {
      const findDecision = item.decisions?.find(
        (i) => i.assetVersionId === assetVersionId
      );
      const decision = findDecision?.decision;
      const lastViewDate = findDecision?.lastViewDate;
      const memberDecision =
        decision ??
        (isPastDueDate ? 'overdue' : lastViewDate ? 'view' : undefined);
      return {
        ...item,
        memberDecision: memberDecision as MemberDecisionProps['decision']
      };
    });
  }, [members, isPastDueDate, assetVersionId]);
  return (
    <div className="campaign-approval-table_decisions-cell">
      <AvatarsGroup
        maxCount={maxCount}
        avatarSize={32}
        isShowDecision={true}
        users={_members}
        membersType="aw_stage_members"
      />
    </div>
  );
});
